var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "magic-zoom" } },
    [
      _c(
        "div",
        { attrs: { itemscope: "", itemtype: "http://schema.org/Thing" } },
        [
          _c(
            "div",
            {
              staticClass: "ItemImgWrap justify-content-center",
              class: { "more-images": _vm.magiczoom.images.all.length > 1 }
            },
            [
              _vm.magiczoom.images.all.length > 1
                ? [
                    _vm.magiczoom.images.all.length >= 4
                      ? _c(
                          "div",
                          {
                            staticClass: "magic-more-images d-none d-lg-block"
                          },
                          [
                            _vm.magiczoom.images.all.length > 4
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-center fa-lg mb-2 cursor",
                                    on: { click: _vm.slidePrev }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-angle-right fa-rotate-270 flipiconZoom "
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "hooper",
                              {
                                ref: "carousel",
                                staticClass: "d-none d-lg-block",
                                attrs: {
                                  vertical: true,
                                  infiniteScroll: false,
                                  itemsToShow: 4,
                                  trimWhiteSpace: true
                                }
                              },
                              [
                                _vm.ytvideo != ""
                                  ? _c("slide", [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "border video d-flex mb-2 videoImage cursor",
                                          on: {
                                            click: function($event) {
                                              return _vm.showVideo()
                                            },
                                            "~mouseover": function($event) {
                                              return _vm.$store.dispatch(
                                                "loadComponent",
                                                "yt-video"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          !_vm.loading
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-play-circle-o"
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "fa fa-circle-o-notch fa-spin"
                                              })
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.magiczoom.images.all, function(
                                  imagePreview,
                                  index
                                ) {
                                  return _c("slide", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "border",
                                        attrs: {
                                          href:
                                            _vm.magiczoom.images.all[index].url,
                                          rel: "zoom-id:ItemImgZoom",
                                          "data-image":
                                            _vm.magiczoom.images.all[index]
                                              .urlSecondPreview
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            "data-src": imagePreview.url,
                                            src: imagePreview.urlPreview
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.magiczoom.images.all.length > 4
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "text-center fa-lg cursor",
                                    on: { click: _vm.slideNext }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-angle-right fa-rotate-90"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "magic-more-images d-none d-lg-block"
                          },
                          [
                            _vm.ytvideo != ""
                              ? [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "border video d-flex mb-2 videoImage",
                                      on: {
                                        click: function($event) {
                                          return _vm.showVideo()
                                        },
                                        "~mouseover": function($event) {
                                          return _vm.$store.dispatch(
                                            "loadComponent",
                                            "yt-video"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      !_vm.loading
                                        ? _c("i", {
                                            staticClass: "fa fa-play-circle-o"
                                          })
                                        : _c("i", {
                                            staticClass:
                                              "fa fa-circle-o-notch fa-spin"
                                          })
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.magiczoom.images.all, function(
                              imagePreview,
                              index
                            ) {
                              return [
                                _c(
                                  "a",
                                  {
                                    staticClass: "mb-2 border",
                                    attrs: {
                                      href: _vm.magiczoom.images.all[index].url,
                                      rel: "zoom-id:ItemImgZoom",
                                      "data-image":
                                        _vm.magiczoom.images.all[index]
                                          .urlMiddle
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        "data-src": imagePreview.url,
                                        src: imagePreview.urlPreview
                                      }
                                    })
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "zoom-xs-left d-lg-none",
                  on: {
                    click: function($event) {
                      return _vm.prevNext("left")
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-angle-left",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "MagicZoomPlus flex-fill d-flex align-items-start justify-content-center",
                  attrs: {
                    href: _vm._f("itemImage")(
                      _vm._f("itemImages")(_vm.magiczoom.images, "url")
                    ),
                    id: "ItemImgZoom",
                    "data-mobile-options":
                      "zoomMode:off; lazyZoom: true; textTouchZoomHint:" +
                      _vm.$translate("Klettershop5::Template.singleZoomHint") +
                      "; textClickZoomHint: " +
                      _vm.$translate("Klettershop5::Template.singleZoomHint2") +
                      "; textExpandHint: " +
                      _vm.$translate("Klettershop5::Template.singleZoomHint"),
                    "data-options":
                      "lazyZoom: true;cssClass: white-bg; zoom-height:500px; textHoverZoomHint:" +
                      _vm.$translate("Klettershop5::Template.singleZoomHint3") +
                      "; textExpandHint:" +
                      _vm.$translate("Klettershop5::Template.singleZoomHint3") +
                      "; zoomPosition: #zoom-placeholder;"
                  }
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: _vm._f("itemImage")(
                        _vm._f("itemImages")(
                          _vm.magiczoom.images,
                          "urlSecondPreview"
                        )
                      ),
                      itemprop: "image"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "zoom-xs-right d-lg-none",
                  on: {
                    click: function($event) {
                      return _vm.prevNext("right")
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-angle-right",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "zoom-navigation-dots d-md-none" })
        ]
      ),
      _vm._v(" "),
      _c("video-container", { attrs: { yt: _vm.ytvideo } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }